<script lang="ts">
	import { onMount } from 'svelte';

	const STORAGE_KEY = 'supertip:theme-mode';
	let dark = $state(false);

	function applyTheme(isDark: boolean): void {
		document.documentElement.classList.toggle('dark', isDark);
	}

	function toggle(): void {
		dark = !dark;
		applyTheme(dark);
		try {
			localStorage.setItem(STORAGE_KEY, dark ? 'dark' : 'light');
		} catch {
			/* localStorage unavailable; ignore */
		}
	}

	onMount(() => {
		try {
			const saved = localStorage.getItem(STORAGE_KEY);
			if (saved === 'dark') dark = true;
			else if (saved === 'light') dark = false;
			else dark = window.matchMedia('(prefers-color-scheme: dark)').matches;
		} catch {
			dark = window.matchMedia('(prefers-color-scheme: dark)').matches;
		}
		applyTheme(dark);
	});
</script>

<button
	type="button"
	role="switch"
	aria-checked={dark}
	aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
	class="relative inline-flex h-6 w-12 items-center rounded-full bg-surface-200 transition-colors dark:bg-surface-700"
	onclick={toggle}
>
	<!-- Sun icon (left) -->
	<span
		class="pointer-events-none absolute left-1 flex h-4 w-4 items-center justify-center transition-opacity"
		class:opacity-100={!dark}
		class:opacity-40={dark}
	>
		<svg
			width="12"
			height="12"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			stroke-width="2"
			stroke-linecap="round"
			aria-hidden="true"
		>
			<circle cx="12" cy="12" r="4" fill="currentColor" />
			<line x1="12" y1="2" x2="12" y2="4" />
			<line x1="12" y1="20" x2="12" y2="22" />
			<line x1="2" y1="12" x2="4" y2="12" />
			<line x1="20" y1="12" x2="22" y2="12" />
			<line x1="4.93" y1="4.93" x2="6.34" y2="6.34" />
			<line x1="17.66" y1="17.66" x2="19.07" y2="19.07" />
			<line x1="4.93" y1="19.07" x2="6.34" y2="17.66" />
			<line x1="17.66" y1="6.34" x2="19.07" y2="4.93" />
		</svg>
	</span>

	<!-- Moon icon (right) -->
	<span
		class="pointer-events-none absolute right-1 flex h-4 w-4 items-center justify-center transition-opacity"
		class:opacity-100={dark}
		class:opacity-40={!dark}
	>
		<svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
			<path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
		</svg>
	</span>

	<!-- Sliding thumb -->
	<span
		class="slide-toggle-thumb absolute top-0.5 h-5 w-5 rounded-full border border-primary-500 bg-white shadow transition-transform duration-200"
		class:translate-x-0.5={!dark}
		class:translate-x-[26px]={dark}
	></span>
</button>
